import React, { Component } from 'react';

import Clock from './clock';

import '../../stylesheets/countdown.css';


class Countdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'deadline': 'December 25,' + new Date().getFullYear(),
            'newDeadline': undefined

        }
    }



    changeDeadline() {
        if (this.state.newDeadline === undefined) {
            this.setState({ newDeadline: null });
            //alert('empty');
        } else {
            const date = this.fromatDate(this.state.newDeadline);
            //console.log(date);
            this.setState({ deadline: date, newDeadline: undefined });
            //console.log(this.state);
        }

    }

    fromatDate(dd) {
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        // console.log(date.getFullYear());
        // console.log(date.getDate());
        // console.log(date.getMonth());
        let date = new Date(dd);
        date = monthNames[date.getMonth()] + ' ' + date.getDate() + ',' + date.getFullYear();
        return date;

    }

    getTomorrowsDate() {
        let date = new Date(); // current date
        let month = date.getMonth() + 1;
        month = month < 10 ? '0' + month : month
        let day = date.getDate() + 1;
        day = day < 10 ? '0' + day : day
        date = date.getFullYear() + '-' + month + '-' + day;
        return date;
    }

    noDateError() {
        const danger = {
            color: 'red',
            fontSize: '0.5em',
        }
        return (
            <div style={danger}>
                You must select a date !
            </div>
        )
    }

    render() {
        return (
            <div className='App container-fluid'>
                <div className='App-title'><small>Countdown to</small> {this.state.deadline}</div>
                <Clock deadline={this.state.deadline} />
                <div className=''>
                    <div className='form-group'>
                        {this.state.newDeadline === null ? this.noDateError() : null}
                        <input type='date'
                            className={`form-control date-input ${this.state.newDeadline === null ? 'date-input-danger' : ''}`}
                            placeholder='new date'
                            onChange={(event) => this.setState({ newDeadline: event.target.value })}
                            //min='2018-08-26'
                            min={this.getTomorrowsDate()}
                            required />

                    </div>
                    <div className='form-group'>
                        <button className='btn btn-primary date-btn'
                            onClick={() => this.changeDeadline()}>
                            Submit</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Countdown;


// WEBPACK FOOTER //
// ./src/components/countdown/Countdown.jsx